




































































































import VueOptions from '@utils/VueOptions'
import CalendarService from '@services/CalendarService'

settings =
  name: 'AudienceListingResourceListItem'

  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor']

    computed:
      activationDate: ->
        { start: date, repeats, rrule: rruleString } = @item.calendar_dates[0]
        CalendarService.formatCalendarDate { date, repeats, rruleString }

    methods:
      badgePotential: (item) ->
        return unless item? 
        return 'unconfirmed' if item.potential_unconfirmed
        return 'confirmed' if item.potential_confirmed
        return 'denied' if item.potential_denied

      badgeState: (item) ->
        return item.state

      badgePublished: (item) ->
        if item.published then 'published' else 'unpublished'

      badgeHorizon: (item) ->
        item.horizon

      statusBadge: (event) ->
        tooltip = ''
        icon = ''
        if event.deactivated
          icon = 'fa-times'
          tooltip = 'Deactivated'
        if event.past
          icon = 'fa-history'
          tooltip = 'Past'
        if event.draft
          icon = 'fa-feather-alt'
          tooltip = 'Draft'
        if event.published
          icon = 'fa-stream'
          tooltip = 'Published'
        return false if !icon || !tooltip
        { icon, tooltip }

      originBadge: (event) ->
        tooltip = ''
        icon = ''
        if event.organizer_created
          tooltip = 'Organizer Created'
          icon = 'fa-user-ninja'
        if event.recess_projected
          tooltip = 'Recess Projected'
          icon = 'fa-magic'
        if event.recess_ghost
          tooltip = 'Recess Ghost'
          icon = 'fa-ghost'
        return false if !icon || !tooltip
        { icon, tooltip }

      hasOfferBadge: (event) ->
        tooltip = ''
        icon = 'fa-hand-holding-usd'
        if @ctxStats(event)?.offer?.count
          tooltip = 'Has Offer'
        else
          tooltip = 'Does not have any offers'
        return false if !icon || !tooltip
        { icon, tooltip }

      verifiedBadgeSrc: (event) ->
        "#{process.env.VUE_APP_IMAGE_ENDPOINT}/indicators/recess_verified_badge.png"

      shouldExpandCollumn: (size) ->
        return true if @rowSize >= 2 && size == 'MEDIUM'
        return true if @rowSize == 3 && size == 'LARGE'

export default VueOptions.vue settings
